// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"bdf148d0","155":"42b6a56b","216":"8927b157","561":"90f116ab","607":"2c6e6ae4","616":"90f8e3c5","671":"702580b9","710":"be47b3b2","714":"e0d7c5a9","737":"9e760755","766":"0bd52eed","825":"69e1df6f","874":"c30d8856","930":"b59a9f15"}[chunkId] + ".chunk.js";
};